import { useState } from "react";

const GOLD = "#C9A96E";
const GOLD_DARK = "#A8813A";
const INK = "#1C1915";
const INK_SOFT = "#6B6460";
const BORDER = "#E7E1D8";
const SOFT_BG = "#F7F5F2";
const WHITE = "#FFFFFF";
const BLUE = "#2E6DB4";
const BG_DARK = "#1C1915";

const PAYS = [
  { code: "MA", label: "Maroc", devise: "MAD", url: "https://maroc.prix-construction.info" },
  { code: "FR", label: "France", devise: "EUR", url: "https://prix-construction.info" },
  { code: "DZ", label: "Algerie", devise: "DZD", url: "https://algerie.prix-construction.info" },
  { code: "SN", label: "Senegal", devise: "XOF", url: "https://senegal.prix-construction.info" },
  { code: "CI", label: "Cote Ivoire", devise: "XOF", url: "https://cote-d-ivoire.prix-construction.info" },
  { code: "CM", label: "Cameroun", devise: "XAF", url: "https://cameroun.prix-construction.info" },
];

const MISSIONS_ARCHI = [
  { num: 1, titre: "Analyse & Conception", desc: "Analyse des besoins du client, definition du style et implantation des espaces." },
  { num: 2, titre: "Modelisation 3D", desc: "Creation de visuels 3D pour valider l amenagement et les choix esthetiques." },
  { num: 3, titre: "Selection mobilier FF&E", desc: "Choix du mobilier, luminaires, textiles et equipements decoratifs." },
  { num: 4, titre: "Consultation fournisseurs", desc: "Analyse et validation des devis fournisseurs." },
  { num: 5, titre: "Coordination commandes", desc: "Suivi des commandes et organisation des livraisons." },
  { num: 6, titre: "Installation & Reception", desc: "Mise en place finale et verification de l amenagement." },
];

const MISSIONS_OPC = [
  { num: 0, titre: "Audit & Stratégie", desc: "Analyse des plans, détection incohérences, vérification budget vs projet réel" },
  { num: 1, titre: "Préparation Opérationnelle", desc: "Planning Gantt, liste entreprises, validation matériaux, plan installation chantier" },
  { num: 2, titre: "Lancement Chantier", desc: "Réunion de lancement, CR signé" },
  { num: 3, titre: "Pilotage Hebdomadaire", desc: "Visites terrain, CR structurés, suivi planning prévu/réel, KPIs chantier" },
  { num: 4, titre: "Coordination Technique", desc: "Réunions OPC, gestion interfaces entre corps d'état, arbitrages techniques" },
  { num: 5, titre: "Gestion des Modifications", desc: "Process obligatoire demande → chiffrage → validation → ordre de service" },
  { num: 6, titre: "Gestion des Retards", desc: "Identification, analyse cause, plan correctif, notification entreprise" },
  { num: 7, titre: "Pré-réception (OPR)", desc: "Inspection complète, liste réserves, planning correctif" },
  { num: 8, titre: "Réception", desc: "PV réception, réserves finales, remise clés" },
  { num: 9, titre: "Clôture & SAV", desc: "Levée réserves, DOE complet, suivi GPA" },
];

const MISSIONS_MANDATAIRE = [
  { num: 0, titre: "Cadrage Juridique & Mandat", desc: "Signature mandat, périmètre, plafond budget, niveau de pouvoir" },
  { num: 1, titre: "Stratégie Financière", desc: "Budget global détaillé, découpage par lots, planning cashflow" },
  { num: 2, titre: "Consultation Entreprises", desc: "Consultation 2-3 entreprises/lot, analyse comparative, négociation" },
  { num: 3, titre: "Contractualisation", desc: "Signature marchés, vérification assurances, ordres de service" },
  { num: 4, titre: "Gestion Financière", desc: "Validation paiements, suivi budget prévu/engagé/payé, gestion trésorerie" },
  { num: 5, titre: "Pilotage Chantier", desc: "Suivi planning, coordination entreprises, gestion retards et modifications" },
  { num: 6, titre: "Gestion des Modifications", desc: "Demande → chiffrage → validation écrite client → intégration budget" },
  { num: 7, titre: "Reporting Client", desc: "Rapport mensuel avancement, budget, alertes, décisions à valider" },
  { num: 8, titre: "Réception", desc: "PV réception, validation travaux, solde paiements" },
  { num: 9, titre: "Clôture Financière", desc: "Bilan final budget initial vs réel, justificatifs, archivage" },
];

const PRIX = [
  {
    cat: "Gros Oeuvre",
    col: BLUE,
    items: [
      { l: "Fondations standard", min: 800, max: 1400, u: "MAD/m2" },
      { l: "Structure beton arme", min: 1200, max: 2000, u: "MAD/m2" },
      { l: "Maconnerie briques", min: 350, max: 600, u: "MAD/m2" },
    ],
  },
  {
    cat: "Finitions interieures",
    col: GOLD_DARK,
    items: [
      { l: "Carrelage sol standard", min: 150, max: 350, u: "MAD/m2" },
      { l: "Carrelage marbre", min: 450, max: 1200, u: "MAD/m2" },
      { l: "Enduit peinture", min: 80, max: 150, u: "MAD/m2" },
      { l: "Faux plafond platre", min: 180, max: 380, u: "MAD/m2" },
    ],
  },
  {
    cat: "Equipements techniques",
    col: "#8B5CF6",
    items: [
      { l: "Plomberie complete villa", min: 35000, max: 80000, u: "MAD/villa" },
      { l: "Electricite complete villa", min: 40000, max: 90000, u: "MAD/villa" },
      { l: "Climatisation split", min: 4500, max: 9000, u: "MAD/unite" },
    ],
  },
  {
    cat: "Renovation",
    col: "#E67E22",
    items: [
      { l: "Renovation complete", min: 2500, max: 5000, u: "MAD/m2" },
      { l: "Renovation partielle", min: 800, max: 2000, u: "MAD/m2" },
    ],
  },
];

const NORMES = [
  {
    titre: "Hauteurs sous plafond",
    items: [
      { l: "Minimum reglementaire Maroc", v: "2,50 m" },
      { l: "Standard YOMA confort", v: "2,80 m" },
      { l: "Premium R+1 et plus", v: "3,00 m+" },
      { l: "Espace noble sejour", v: "3,20 m recommande" },
    ],
  },
  {
    titre: "Epaisseurs de murs",
    items: [
      { l: "Mur exterieur porteur", v: "30 cm" },
      { l: "Mur interieur separation", v: "15 cm" },
      { l: "Cloison legere", v: "10 cm" },
      { l: "Mur piscine", v: "25 cm min." },
    ],
  },
  {
    titre: "Surfaces minimales",
    items: [
      { l: "Chambre principale", v: "16 m2 min." },
      { l: "Chambre secondaire", v: "12 m2 min." },
      { l: "Salle de bain", v: "6 m2 min." },
      { l: "Cuisine", v: "10 m2 recommande" },
    ],
  },
  {
    titre: "Coefficients de marge YOMA",
    items: [
      { l: "Marge YOMA sur travaux", v: "8 - 12%" },
      { l: "Imprevus chantier", v: "+10% budget HT" },
      { l: "Avenants anticipes", v: "+5% buffer" },
      { l: "TVA Maroc", v: "20% si applicable" },
    ],
  },
];

function initHonSel(missions) {
  const hon = {};
  const sel = {};
  missions.forEach((m) => {
    hon[m.num] = "";
    sel[m.num] = true;
  });
  return { hon, sel };
}

function totalHonoraires(hon, sel) {
  return Object.entries(hon)
    .filter(([k]) => sel[k])
    .reduce((s, [, v]) => s + (parseFloat(v) || 0), 0);
}

function EtapesMissionBlock({
  missions,
  hon,
  setHon,
  sel,
  setSel,
  paysObj,
  headerTitle,
  headerSubtitle,
  headerEmoji,
}) {
  const total = totalHonoraires(hon, sel);
  return (
    <div><div
        style={{
          background: BG_DARK,
          borderRadius: 14,
          padding: "20px 24px",
          marginBottom: 20,
          display: "flex",
          alignItems: "center",
          gap: 16,
        }}
      >
        {headerEmoji ? <div style={{ fontSize: 36, lineHeight: 1 }}>{headerEmoji}</div> : null}
        <div>
          <div style={{ fontSize: 14, fontWeight: 800, color: WHITE }}>{headerTitle}</div><div style={{ fontSize: 12, color: "#aaa", marginTop: 4 }}>{headerSubtitle}</div></div></div><div style={{ background: WHITE, border: "1px solid " + BORDER, borderRadius: 14, overflow: "hidden", marginBottom: 16 }}><div
          style={{
            display: "grid",
            gridTemplateColumns: "40px 1fr 2fr 160px",
            padding: "10px 20px",
            gap: 12,
            background: SOFT_BG,
            borderBottom: "1px solid " + BORDER,
          }}
        >
          {["", "Étape", "Description", "Honoraires"].map((h, i) => (
            <div key={i} style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.1em", color: INK_SOFT }}>
              {h}
            </div>
          ))}
        </div>
        {missions.map((m) => {
          const s = sel[m.num];
          return (
            <div
              key={m.num}
              style={{
                display: "grid",
                gridTemplateColumns: "40px 1fr 2fr 160px",
                padding: "14px 20px",
                gap: 12,
                alignItems: "center",
                borderBottom: "1px solid " + BORDER,
                background: s ? WHITE : "#FAFAFA",
                opacity: s ? 1 : 0.5,
              }}
            ><input
                type="checkbox"
                checked={s}
                onChange={(e) => setSel((p) => ({ ...p, [m.num]: e.target.checked }))}
                style={{ width: 16, height: 16, accentColor: GOLD, cursor: "pointer" }}
              /><div style={{ display: "flex", alignItems: "center", gap: 10 }}><div
                  style={{
                    width: 30,
                    height: 30,
                    borderRadius: "50%",
                    background: s ? GOLD : BORDER,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 12,
                    fontWeight: 800,
                    color: s ? WHITE : INK_SOFT,
                    flexShrink: 0,
                  }}
                >
                  {m.num}
                </div><div style={{ fontSize: 13, fontWeight: 700, color: INK }}>{m.titre}</div></div><div style={{ fontSize: 12, color: INK_SOFT }}>{m.desc}</div><div style={{ position: "relative" }}><input
                  type="number"
                  placeholder="0"
                  value={hon[m.num] ?? ""}
                  onChange={(e) => setHon((p) => ({ ...p, [m.num]: e.target.value }))}
                  disabled={!s}
                  style={{
                    width: "100%",
                    padding: "7px 48px 7px 10px",
                    border: "1px solid " + BORDER,
                    borderRadius: 8,
                    fontSize: 13,
                    fontWeight: 600,
                    color: INK,
                    boxSizing: "border-box",
                    outline: "none",
                    textAlign: "right",
                    background: s ? WHITE : "transparent",
                  }}
                /><span
                  style={{
                    position: "absolute",
                    right: 8,
                    top: "50%",
                    transform: "translateY(-50%)",
                    fontSize: 10,
                    color: INK_SOFT,
                    pointerEvents: "none",
                  }}
                >
                  {paysObj.devise}
                </span></div></div>
          );
        })}
        <div style={{ display: "grid", gridTemplateColumns: "40px 1fr 2fr 160px", padding: "14px 20px", gap: 12, alignItems: "center", background: BG_DARK }}><div /><div style={{ fontSize: 11, fontWeight: 800, color: WHITE, textTransform: "uppercase", letterSpacing: "0.1em", gridColumn: "2/4" }}>
            Total honoraires mission
          </div><div style={{ fontSize: 16, fontWeight: 900, color: GOLD, textAlign: "right" }}>
            {total > 0 ? total.toLocaleString("fr-FR") + " " + paysObj.devise : "--"}
          </div></div></div></div>
  );
}

export default function YomaKnowledgePage() {
  const [onglet, setOnglet] = useState("archi");
  const [pays, setPays] = useState("MA");

  const archiInit = initHonSel(MISSIONS_ARCHI);
  const [honArchi, setHonArchi] = useState(archiInit.hon);
  const [selArchi, setSelArchi] = useState(archiInit.sel);

  const opcInit = initHonSel(MISSIONS_OPC);
  const [honOpc, setHonOpc] = useState(opcInit.hon);
  const [selOpc, setSelOpc] = useState(opcInit.sel);

  const mandInit = initHonSel(MISSIONS_MANDATAIRE);
  const [honMand, setHonMand] = useState(mandInit.hon);
  const [selMand, setSelMand] = useState(mandInit.sel);

  const paysObj = PAYS.find((p) => p.code === pays) || PAYS[0];

  const tabSt = (a) => ({
    padding: "10px 20px",
    border: "none",
    borderRadius: "8px 8px 0 0",
    background: a ? WHITE : "transparent",
    color: a ? GOLD_DARK : INK_SOFT,
    fontWeight: a ? 700 : 500,
    fontSize: 13,
    cursor: "pointer",
    borderBottom: a ? "2px solid " + GOLD : "2px solid transparent",
  });

  return (
    <div style={{ fontFamily: "system-ui", color: INK, paddingBottom: 40 }}><div style={{ marginBottom: 28 }}><div style={{ fontSize: 10, letterSpacing: "0.18em", textTransform: "uppercase", color: GOLD, fontWeight: 700, marginBottom: 6 }}>
          REPORTING
        </div><h1 style={{ margin: "0 0 6px", fontSize: 26, fontWeight: 800 }}>Referentiel YOMA</h1><p style={{ margin: 0, fontSize: 13, color: INK_SOFT }}>Standards operationnels, grilles de mission et prix de reference.</p></div><div style={{ borderBottom: "2px solid " + BORDER, marginBottom: 24, display: "flex", gap: 4, flexWrap: "wrap" }}><button onClick={() => setOnglet("archi")} style={tabSt(onglet === "archi")}>
          Architecture Intérieure
        </button><button onClick={() => setOnglet("opc")} style={tabSt(onglet === "opc")}>
          OPC
        </button><button onClick={() => setOnglet("mandataire")} style={tabSt(onglet === "mandataire")}>
          Mandataire
        </button><button onClick={() => setOnglet("prix")} style={tabSt(onglet === "prix")}>
          Prix de Reference
        </button><button onClick={() => setOnglet("normes")} style={tabSt(onglet === "normes")}>
          Normes et Standards
        </button></div>

      {onglet === "archi" && (
        <EtapesMissionBlock
          missions={MISSIONS_ARCHI}
          hon={honArchi}
          setHon={setHonArchi}
          sel={selArchi}
          setSel={setSelArchi}
          paysObj={paysObj}
          headerTitle="Mission Architecture Intérieure"
          headerSubtitle="Cochez les etapes et saisissez les honoraires."
        />
      )}

      {onglet === "opc" && (
        <EtapesMissionBlock
          missions={MISSIONS_OPC}
          hon={honOpc}
          setHon={setHonOpc}
          sel={selOpc}
          setSel={setSelOpc}
          paysObj={paysObj}
          headerTitle="Mission OPC"
          headerSubtitle="Cochez les etapes et saisissez les honoraires."
        />
      )}

      {onglet === "mandataire" && (
        <EtapesMissionBlock
          missions={MISSIONS_MANDATAIRE}
          hon={honMand}
          setHon={setHonMand}
          sel={selMand}
          setSel={setSelMand}
          paysObj={paysObj}
          headerTitle="Mission Mandataire"
          headerSubtitle="Cochez les etapes et saisissez les honoraires."
        />
      )}

      {onglet === "prix" && (
        <div><div style={{ background: WHITE, border: "1px solid " + BORDER, borderRadius: 14, padding: "18px 22px", marginBottom: 20 }}><div style={{ fontSize: 11, fontWeight: 700, color: GOLD, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 12 }}>
              Pays du projet
            </div><div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
              {PAYS.map((p) => (
                <button
                  key={p.code}
                  onClick={() => setPays(p.code)}
                  style={{
                    padding: "8px 16px",
                    borderRadius: 8,
                    cursor: "pointer",
                    fontSize: 13,
                    fontWeight: pays === p.code ? 700 : 500,
                    background: pays === p.code ? GOLD : SOFT_BG,
                    color: pays === p.code ? WHITE : INK,
                    border: "1px solid " + (pays === p.code ? GOLD_DARK : BORDER),
                  }}
                >
                  {p.label}
                </button>
              ))}
            </div><div style={{ marginTop: 14, paddingTop: 14, borderTop: "1px solid " + BORDER, display: "flex", justifyContent: "space-between", alignItems: "center" }}><span style={{ fontSize: 12, color: INK_SOFT }}>Source : Generateur de Prix CYPE -- {paysObj.label}</span><a href={paysObj.url} target="_blank" rel="noopener noreferrer" style={{ padding: "7px 14px", background: BLUE, color: WHITE, borderRadius: 8, fontSize: 12, fontWeight: 700, textDecoration: "none" }}>
                Consulter les prix
              </a></div></div>
          {PRIX.map((cat, ci) => (
            <div key={ci} style={{ background: WHITE, border: "1px solid " + BORDER, borderRadius: 14, overflow: "hidden", marginBottom: 14 }}><div style={{ padding: "12px 20px", background: SOFT_BG, borderBottom: "1px solid " + BORDER, display: "flex", alignItems: "center", gap: 10 }}><div style={{ width: 10, height: 10, borderRadius: "50%", background: cat.col }} /><div style={{ fontSize: 12, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.08em", color: INK }}>{cat.cat}</div></div>
              {cat.items.map((item, ii) => (
                <div
                  key={ii}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "12px 20px",
                    borderBottom: ii < cat.items.length - 1 ? "1px solid " + BORDER : "none",
                    gap: 16,
                  }}
                ><div style={{ flex: 1, fontSize: 13, color: INK }}>{item.l}</div><div style={{ display: "flex", alignItems: "center", gap: 6 }}><span style={{ fontSize: 12, fontWeight: 700, color: cat.col }}>{item.min.toLocaleString("fr-FR")}</span><span style={{ fontSize: 11, color: INK_SOFT }}>-&gt;</span><span style={{ fontSize: 12, fontWeight: 700, color: cat.col }}>{item.max.toLocaleString("fr-FR")}</span><span style={{ fontSize: 10, color: INK_SOFT, background: SOFT_BG, border: "1px solid " + BORDER, borderRadius: 6, padding: "2px 8px" }}>{item.u}</span></div></div>
              ))}
            </div>
          ))}
        </div>
      )}

      {onglet === "normes" && (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
          {NORMES.map((bloc, i) => (
            <div key={i} style={{ background: WHITE, border: "1px solid " + BORDER, borderRadius: 14, overflow: "hidden" }}><div style={{ background: BG_DARK, padding: "14px 18px" }}><div style={{ fontSize: 12, fontWeight: 800, color: WHITE, textTransform: "uppercase", letterSpacing: "0.06em" }}>{bloc.titre}</div></div>
              {bloc.items.map((item, ii) => (
                <div
                  key={ii}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px 18px",
                    borderBottom: ii < bloc.items.length - 1 ? "1px solid " + BORDER : "none",
                  }}
                ><span style={{ fontSize: 12, color: INK_SOFT }}>{item.l}</span><span style={{ fontSize: 12, fontWeight: 700, color: INK, background: SOFT_BG, border: "1px solid " + BORDER, borderRadius: 6, padding: "3px 10px" }}>{item.v}</span></div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
